import type { SeriesPoint } from '@/logic/oapAttainment';

// A 30-day trace beside the numbers it summarises. Decorative: the row's baseline and current cells
// carry the facts, so it is hidden from assistive tech rather than read out as coordinates.
const W = 72;
const H = 22;
const PAD = 2;

export default function Sparkline({ points }: { points: readonly SeriesPoint[] }) {
  if (points.length < 2) return <span className="oap-spark oap-spark--empty" aria-hidden="true" />;
  const xs = points.map((p) => p.epoch);
  const ys = points.map((p) => p.value);
  const x0 = Math.min(...xs);
  const x1 = Math.max(...xs);
  const y0 = Math.min(...ys);
  const y1 = Math.max(...ys);
  const sx = (x: number) => (x1 === x0 ? W / 2 : PAD + ((x - x0) / (x1 - x0)) * (W - 2 * PAD));
  const sy = (y: number) => (y1 === y0 ? H / 2 : H - PAD - ((y - y0) / (y1 - y0)) * (H - 2 * PAD));
  const d = points.map((p, i) => `${i === 0 ? 'M' : 'L'}${sx(p.epoch).toFixed(1)} ${sy(p.value).toFixed(1)}`).join(' ');
  const last = points[points.length - 1]!;
  return (
    <svg className="oap-spark" width={W} height={H} viewBox={`0 0 ${W} ${H}`} aria-hidden="true">
      <path d={d} fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={sx(last.epoch)} cy={sy(last.value)} r="2" fill="currentColor" />
    </svg>
  );
}
